export function buildQuillEditorModules(token: string, enableToolbar: boolean = true) {
  return {
    toolbar: enableToolbar
      ? [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          ["clean"],
        ]
      : false,
    spaceNormalizer: true,
    languageTool: {
      server: "/api/languagetool/inline",
      language: "de-AT",
      cooldownTime: 500,
      showLoadingIndicator: true,
      disableNativeSpellcheck: false,
      apiOptions: { token },
    },
  };
}
